import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import * as firebase from 'firebase/app';
import { Utils } from '../util';

interface Payroll {
    active: boolean;
    acceptanceDate: any;
    acceptanceUser?: string;
    createdAt: any;
    endDate: any;
    startDate: any;
    status: number;
    updatedAt: any;
}

interface PayrollId extends Payroll {
    id: string;
}

interface EmployeePayroll {
    createdAt: any;
    dates: any;
    employeeId: string;
    employeeName: string;
    employeeFolio: string;
    employeeDepartmentId?: string;
    payroll: any;
    carrier: any;
    overtime: any;
    loan: any;
    updatedAt: any;
}

interface EmployeePayrollId extends EmployeePayroll {
    id: string;
}

@Injectable()
export class PayrollService {

    payrollCollection: AngularFirestoreCollection<Payroll>;
    payrolls: any;

    payrollDocument: AngularFirestoreDocument<PayrollId>;
    payroll: Observable<any>;

    employeePayrollCollection: any;
    employeesPayroll: any;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.PAYROLL_COLLECTION;
    }

    _tempDeletePayroll(payrollId: string){
        return this.afs.collection(this.collection).doc(payrollId).delete();
    }

    postPayroll(payrollId: string, payrollObject: any) {
        this.payrollCollection = this.afs.collection(this.collection);

        return this.payrollCollection.doc(payrollId).set(payrollObject).then(function() {
            // console.log('Document added with ID: ', docRef.id);
            return payrollId;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
            return '';
        });
    }

    getPayroll(payrollId: string) {
        this.payrollDocument = this.afs.doc(this.collection + '/' + payrollId);

        this.payroll = this.payrollDocument.valueChanges();

        return this.payroll.map(object => object);
    }

    postPayrollEmployeesAtomic(payrollId: string, employees: any) {
        console.log(employees);
        //if(1) return;
        const batch = firebase.firestore().batch();

        this.employeePayrollCollection = firebase.firestore().collection(this.collection).doc(payrollId).collection('employees');

        for (let item in employees) {
            const employeeRef = this.employeePayrollCollection.doc(employees[item].employeeId);
            for(let key in employees[item]){ console.log(key, employees[item][key]) };
            batch.set(employeeRef, employees[item]);
        }

        return batch.commit();
    }

    getPayrollEmployees(payrollId: string) {
        this.payrollDocument = this.afs.doc(this.collection + '/' + payrollId);

        this.payroll = this.payrollDocument.snapshotChanges().map(action => {
            const id$ = action.payload.id;

            const data = action.payload.data() as Payroll;

            return { id$, ...data };
        }).map(document => {
            this.employeePayrollCollection = this.afs.doc(this.collection + '/' + document.id$)
                              .collection('employees', ref => ref.orderBy('employeeName', 'asc'));

            const employeesRef: any = this.employeePayrollCollection.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const id$ = a.payload.doc.id;

                    const data = a.payload.doc.data() as EmployeePayroll;

                    return { id$, ...data };
                });
            });

            return Observable.combineLatest(employeesRef, (employeesData) => {
                return {
                    employees: employeesData
                };
            }).map(data => {
                return {
                    employees: data.employees,
                    ...document
                };
            });
        }).mergeMap(object => Observable.combineLatest(object));

        return this.payroll;
    }

    getPayrolls() {
        this.payrollCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', true).orderBy('createdAt', 'asc'));

        this.payrolls = this.payrollCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Payroll;

                const endDate = data.endDate;
                const startDate = data.startDate;
                const status = data.status;

                return { id$, endDate, startDate, status };
            });
        }).map(object => object);

        return this.payrolls;
    }

}
